import AntdDatePicker from 'antd/lib/date-picker'
import type {
  DatePickerProps as AntdDatePickerProps,
  DatePickerDecorator,
} from 'antd/lib/date-picker/interface'
import { connectReadonlyComponent } from '../connect'
import { PreviewText } from '../preview-text'
import 'antd/lib/date-picker/style'

export * from 'antd/lib/date-picker'

export * from 'antd/lib/date-picker/interface'

export type DatePickerProps = AntdDatePickerProps & {
  readonly?: boolean
}

export const DatePicker = connectReadonlyComponent(
  AntdDatePicker,
  PreviewText.DatePicker
) as unknown as DatePickerDecorator

const { MonthPicker, WeekPicker, RangePicker } = AntdDatePicker

Object.assign(DatePicker, {
  MonthPicker: connectReadonlyComponent(MonthPicker, PreviewText.MonthPicker),
  RangePicker: connectReadonlyComponent(RangePicker, PreviewText.DatePicker),
  WeekPicker: connectReadonlyComponent(WeekPicker, PreviewText.WeekPicker),
})

export default DatePicker
